import React from 'react'

const Logo = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 368 369" {...props}>
		<path fill="#5D9FE2" d="M36 101.3L49.8 50 .7 233.1z" />
		<path fill="#CDDBFE" d="M183 183.2l92.3-24.7-14-52.4-105.3-28-78.1 78.2 28.2 105.3 52.1 14.1z" />
		<path fill="#5D9FE2" d="M49.9 50h-.1zM275.3 158.5L183 183.2l-24.8 92.5 53.1 14.3 78.2-78.2z" />
		<path fill="#5850EC" d="M275.3 158.5L183 183.2l-24.8 92.5 53.1 14.3 78.2-78.2z" />
		<path fill="#5D9FE2" d="M.7 233.1l-.1.6zM318.6 319L135 368.2zM106.1 261.6L134 366l24.2-90.3z" />
		<path fill="#6875F5" d="M106.1 261.6L134 366l24.2-90.3z" />
		<path fill="#5D9FE2" d="M.7 233.1l-.1.6zM.7 233.1l-.1.6zM134 366l.3 1.1 77-77.1-53.1-14.3z" />
		<path fill="#5D9FE2" d="M134 366l.3 1.1 77-77.1-53.1-14.3z" />
		<path fill="#5145CD" d="M134 366l.3 1.1 77-77.1-53.1-14.3z" />
		<path fill="#5D9FE2" d="M233.3.9l.2-.1zM261.3 106.1l14 52.4 91.4-24.5.3.3.9 1L233.5.8 366.7 134z" />
		<path fill="#6875F5" d="M366.7 134l-105.4-27.9 14 52.4 91.4-24.5.3.3.9 1" />
		<path fill="#5D9FE2" d="M367 134.3l-.3-.3-91.4 24.5 14.2 53.3z" />
		<path fill="#5D9FE2" d="M367 134.3l-.3-.3-91.4 24.5 14.2 53.3z" />
		<path fill="#5145CD" d="M367 134.3l-.3-.3-91.4 24.5 14.2 53.3z" />
		<path fill="#5D9FE2" d="M49.6 50.7l28.3 105.6L156 78.1 49.9 50h-.1L36 101.3z" />
		<path fill="#F0F5FF" d="M49.6 50.7l28.3 105.6L156 78.1 49.9 50h-.1L36 101.3z" />
		<path fill="#5D9FE2" d="M233.3.9L49.9 50zM233.3.9L156 78.1l105.3 28L233.3.9 49.9 50z" />
		<path fill="#B4C6FC" d="M233.3.9L156 78.1l105.3 28L233.3.9 49.9 50z" />
		<path fill="#5D9FE2" d="M233.5.8l-.2.1zM233.5.8l-.2.1zM261.3 106.1L366.7 134 233.5.8l-.2.1z" />
		<path fill="#5D9FE2" d="M261.3 106.1L366.7 134 233.5.8l-.2.1z" />
		<path fill="#5850EC" d="M261.3 106.1L366.7 134 233.5.8l-.2.1z" />
		<path fill="#5D9FE2" d="M49.9 50L156 78.1 233.3.9z" />
		<path fill="#5D9FE2" d="M49.9 50L156 78.1 233.3.9z" />
		<path fill="#CDDBFE" d="M49.9 50L156 78.1 233.3.9z" />
		<path fill="#5D9FE2" d="M1 233.2l105.1 28.4-28.2-105.3z" />
		<path fill="#B4C6FC" d="M1 233.2l105.1 28.4-28.2-105.3z" />
		<path fill="#5D9FE2" d="M.7 233.1L36 101.3zM.7 233.1L36 101.3zM133.8 366.9l.2-.9-27.9-104.4L1 233.2l-.4.3.1-.4-.1.6 133.5 133.6z" />
		<path fill="#5D9FE2" d="M133.8 366.9l.2-.9-27.9-104.4L1 233.2l-.4.3.1-.4-.1.6 133.5 133.6z" />
		<path fill="#5850EC" d="M133.8 366.9l.2-.9-27.9-104.4L1 233.2l-.4.3.1-.4-.1.6 133.5 133.6z" />
		<path fill="#5D9FE2" d="M133.8 366.9l.3.4.2-.2-.3-1.1z" />
		<path fill="#5D9FE2" d="M133.8 366.9l.3.4.2-.2-.3-1.1z" />
		<path fill="#5D9FE2" d="M133.8 366.9l.3.4.2-.2-.3-1.1z" />
		<path fill="#5D9FE2" d="M133.8 366.9l.3.4.2-.2-.3-1.1zM49.6 50.7L36 101.3.7 233.1l.3.1 76.9-76.9z" />
		<path fill="#5D9FE2" d="M49.6 50.7L36 101.3.7 233.1l.3.1 76.9-76.9z" />
		<path fill="#CDDBFE" d="M49.6 50.7L36 101.3.7 233.1l.3.1 76.9-76.9z" />
		<path fill="#5D9FE2" d="M.6 233.5l.4-.3-.3-.1z" />
		<path fill="#5D9FE2" d="M.6 233.5l.4-.3-.3-.1z" />
		<path fill="#5D9FE2" d="M.6 233.5l.4-.3-.3-.1z" />
		<path fill="#5D9FE2" d="M.6 233.5l.4-.3-.3-.1zM211.3 290l106.8 28.9-28.6-107.1z" />
		<path fill="#5D9FE2" d="M211.3 290l106.8 28.9-28.6-107.1z" />
		<path fill="#42389D" d="M211.3 290l106.8 28.9-28.6-107.1z" />
		<path fill="#5D9FE2" d="M318.6 319h.1zM318.6 319h.1zM318.6 319h.1zM134.5 367.6l.5.6zM134.5 367.6l.5.6zM134.5 367.6l.5.6zM318.1 319.1v-.2L211.3 290l-77 77.1.2.5.5.6L318.6 319z" />
		<path fill="#5D9FE2" d="M318.1 319.1v-.2L211.3 290l-77 77.1.2.5.5.6L318.6 319z" />
		<path fill="#5D9FE2" d="M318.1 319.1v-.2L211.3 290l-77 77.1.2.5.5.6L318.6 319z" />
		<path fill="#362F78" opacity=".9" d="M318.1 319.1v-.2L211.3 290l-77 77.1.2.5.5.6L318.6 319z" />
		<path fill="#5D9FE2" d="M367 134.3l.9 1zM367 134.3l.9 1zM367 134.3l.9 1zM289.5 211.8l28.6 107.1.5.1h.1l49.2-183.7-.9-1z" />
		<path fill="#5D9FE2" d="M289.5 211.8l28.6 107.1.5.1h.1l49.2-183.7-.9-1z" />
		<path fill="#5D9FE2" d="M289.5 211.8l28.6 107.1.5.1h.1l49.2-183.7-.9-1z" />
		<path fill="#362F78" opacity=".9" d="M289.5 211.8l28.6 107.1.5.1h.1l49.2-183.7-.9-1z" />
		<path fill="#5D9FE2" d="M318.1 319.1l.5-.1-.5-.1z" />
		<path fill="#5D9FE2" d="M318.1 319.1l.5-.1-.5-.1z" />
		<path fill="#5D9FE2" d="M318.1 319.1l.5-.1-.5-.1z" />
		<path fill="#5D9FE2" d="M318.1 319.1l.5-.1-.5-.1z" />
		<path fill="#5D9FE2" d="M318.1 319.1l.5-.1-.5-.1zM134.1 367.3l.4.3zM134.1 367.3l.4.3zM134.1 367.3l.4.3zM134.1 367.3l.4.3zM134.5 367.6l-.2-.5-.2.2z" />
		<path fill="#5D9FE2" d="M134.5 367.6l-.2-.5-.2.2z" />
		<path fill="#5D9FE2" d="M134.5 367.6l-.2-.5-.2.2z" />
		<path fill="#5D9FE2" d="M134.5 367.6l-.2-.5-.2.2z" />
		<path fill="#5D9FE2" d="M134.5 367.6l-.2-.5-.2.2z" />
	</svg>
)

export default Logo
